import { isMap as isMap$1 } from '../../predicate/isMap.mjs';

function isMap(value) {
    return isMap$1(value);
}

export { isMap };
